import { FC, useState, useRef } from 'react';
import { parseISO, format } from 'date-fns';
import { ru } from 'date-fns/locale';
import { getShortTimeString, getTruncatedTxt } from '@/helpers/helpers';
import { DEV_ABSOLUTE_URL } from '@/helpers/variables';
import styles from './PodcastsDetail.module.scss';

interface IPodcastsDetailItem {
  externail_id: number;
  description: string | undefined;
  podcastNumber: number;
  title: string;
  duration: string;
  created_at: string;
  rating: number;
}

const PodcastsDetailItem: FC<IPodcastsDetailItem> = ({ externail_id, description, podcastNumber, title, duration, created_at, rating }) => {
  const [activeItem, setActiveItem] = useState(false);

  const refPlayer = useRef<HTMLAudioElement>(null);

  const playAudio = () => refPlayer.current?.play();

  const openItemHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    if (activeItem) {
      setActiveItem(false);
    } else {
      setActiveItem(true);
      setTimeout(() => {
        playAudio();
      }, 300);
    }
  };

  return (
    <li className={styles.podcastsList__item}>
      <div className={styles.podcastsList__title} onClick={openItemHandler}>
        <span className={styles.podcastsList__titleNumber}>{podcastNumber}. </span>
        {title}
      </div>
      <div className={styles.podcastsList__info}>
        {activeItem ? <div className={`${styles.podcastsList__btnPlay} ${styles.podcastsList__btnPlay_active}`}></div> : <div className={styles.podcastsList__btnPlay} onClick={openItemHandler}></div>}

        <span className={styles.podcastsList__time}>{getShortTimeString(duration)}</span>
        <span className={styles.podcastsList__date}>{format(parseISO(created_at), 'dd MMMM yyyy', { locale: ru })}</span>
        <span className={styles.podcastsList__rating}>{rating}</span>
      </div>
      <div className={styles.podcastsList__txt}>
        {!activeItem ? (
          <>
            {description && description!.length > 0 && getTruncatedTxt(String(description), 200)}{' '}
            <div className={styles.podcastsList__btnMore} onClick={() => setActiveItem(true)}>
              Подробнее
            </div>
          </>
        ) : (
          <>
            <div className={styles.podcastsList__txt}>{description}</div>
            <div className={styles.podcastsList__controls}>
              <div className={styles.podcastsList__player}>
                <audio ref={refPlayer} controls>
                  {/* <source src={`https://kuchaknig.org/api/v1/satellite/podcast/get-file?podcast_item_external_id=${externail_id}`} type="audio/mpeg" /> */}
                  <source src={`${DEV_ABSOLUTE_URL}/api/v1/satellite/podcast/get-file?podcast_item_external_id=${externail_id}`} type="audio/mpeg" />
                </audio>
              </div>
              <div className={styles.podcastsList__btnMore} onClick={() => setActiveItem(false)}>
                Cвернуть подкаст
              </div>
            </div>
          </>
        )}
      </div>
    </li>
  );
};
export default PodcastsDetailItem;
